import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import {
  GetRDSAzzurroEventsQuery,
  RDSAzzurroEventsFilter,
  RDSAzzurroEventsSortInput,
  RDSPaginationInput
} from 'ngx-core-services';

const getEventFragment = `
  fragment rdsazzurroeventstype on RDSAzzurroEventsType {
    azzurroEvents {
      azzurroEvent
      arm
      dspm
      dsps
      deviceId
      status
      batteryModel
      createdAt
      updatedAt
    }
    totalCount
  }
`;

@Injectable()
export class EventRegistryService {

  constructor(private readonly getRDSAzzurroEventsQuery: GetRDSAzzurroEventsQuery) { }

  async getEvents(
    pagination: RDSPaginationInput,
    filter?: RDSAzzurroEventsFilter,
    sort?: RDSAzzurroEventsSortInput
  ) {
    const query = gql`${getEventFragment}`;
    const { data } = await this.getRDSAzzurroEventsQuery.execute(
      query,
      {
        input: {
          pagination,
          filter,
          sort,
        },
      },
      true,
    );

    return data?.getRDSAzzurroEvents;
  }
}